import React from 'react';
import CateGorySelector from '@/pages/dashboard/components/CateGorySelector';
import {  formatCategoryOptions } from '../../components/NewFilter/util';
import SelectorMultiple from '../../components/SelectorMultiple';
import { LANGUAGE_CN } from '../../_config/constant';
import { FormatOptionsParamsType } from '../../components/NewFilter/_type';

const formatSourceOption = (config: FormatOptionsParamsType) => {
  const { options, valueKey, locale, cnKey = '', enKey = '' } = config;
  const optionsVal = options?.filter(item => item?.[valueKey] !== '255');
  return (optionsVal || []).map((item: any) => {
    const text = (locale === LANGUAGE_CN ? item?.[cnKey] : item?.[enKey]) || item?.[enKey] || item?.[cnKey];
    const value = item?.[valueKey];
    return {
      ...item,
      value,
      text,
      // icon: item?.[iconKey] || importSvg(value),
    };
  });
};

// 产品类型
export const renderCategory = (props: any): React.ReactElement => {
  const { key, value, options, onChange, locale, getLocalText, onClose, name, allInfo, lftName, rtName, ...restProps } = props || {};
  const  language = {
    en: {
      'button_region': name || 'Product',
      'button_market': lftName || 'Category/Product',
      'region_title': rtName || 'Product Category',
    },
    cn: {
      'button_region': name || '产品',
      'button_market': lftName || '产品类型/产品',
      'region_title': rtName || '产品类型',
    }
  };
  const productList = (() => {
    const arr: any[] = [];
    options?.forEach(category => {
      if (category.product_set && Array.isArray(category.product_set)) {
        category.product_set?.map(product => {
          arr?.push({
            product_code: product?.product_code,
            category_code: category?.category_code,
          });
        });
      }
    });
    return arr;
  })();
  return <CateGorySelector
    matchButtonWidth
    key={key}
    className={'search-items-country search-items-category js-search-items-country'}
    value={value}
    language={language}
    onChange={(value) => {
      let category;
      const product = value?.markets;
      if (product?.[0] === '255') {
        category = ['255'];
      } else {
        const newCategory: any = [];
        product?.map(item => {
          const productItem = productList?.find(v => v?.product_code === item);
          newCategory?.push(productItem?.category_code);
        });
        category = [...new Set(newCategory)];
      }
      const newValue = {
        product: product ?? ['255'],
        category: category ?? ['255'],
        category_type: value?.type === 'region' ? 'category' : 'product',
        type: value?.type === 'region' ? 'category' : 'product',
      };
      onChange(key, newValue);
    }}
    onClose={() => {
      onClose?.(value);
    }}
    locale={locale}
    // popularList={popularList}，// 在restProps里面
    globalMessageHidden
    globalMsg={allInfo || getLocalText('region_selector_global_message', {}, false)}
    regionCountry={formatCategoryOptions(options)}
    // {...(value?.otherConfig || {})}
    {...restProps}
  />;
};

export const renderLanguage = (props: any): React.ReactElement => {
  const { key, value, options, defaultValue, onChange, locale, name, allInfo, getLocalText, ...restProps } = props || {};
  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    showTips
    tipsInfo={getLocalText('funnel_funnel_language_expresion', {}, false)}
    label={name || getLocalText('selector_multiple_component_language_label', {}, false)}
    allDescribe={getLocalText('selector_multiple_component_language_all_describe', {}, false)}
    allInfo={allInfo || getLocalText('selector_multiple_component_language_all_info', {}, false)}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatSourceOption({
      options,
      locale,
      valueKey: 'lang_code',
      cnKey: 'lang_name_ch',
      enKey: 'lang_name_en'
    })}
    {...restProps}
  />;
};